import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import credential from "../../API/Credentials.json";
import { apiRequest } from "../../API/apiServices";
const apiMethod = credential?.request?.post;

export const diabetesPredictor = createAsyncThunk(
  "diabetes/diabetesPredictor",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.DiabetesPredictor_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apiData);
      if (response && response.success) {
        return response;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateDiabetesData = createAsyncThunk(
  "diabetes/updateDiabetesData",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.UpdateDiabetesData_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apiData);
      if (response && response.success) {
        return response;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DiabetesSlice = createSlice({
  name: "diabetes",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(diabetesPredictor.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(diabetesPredictor.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(diabetesPredictor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = true;
      })
      .addCase(updateDiabetesData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateDiabetesData.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(updateDiabetesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = true;
      });
  },
});
export default DiabetesSlice.reducer;
